<template>
    <div class="footer bg-white">
<!--        <carousel v-if="blogs != null && blogs.length > 0 && !oracle.isMobile()" :dots="false" :autoplay="true" :autoWidth="true"-->
<!--                  :autoHeight="true" :center="true" :nav="false">-->
<!--            <div v-for="(item, index) in blogs" :key="index" class="mt-5 mb-5 ml-2 mr-2"-->
<!--                 @click="$router.push({name: 'article', params: {id: item.blog_id}})">-->
<!--                <div v-ripple class="card card-lift&#45;&#45;hover shadow border-0">-->
<!--                    <div style="width: 400Px;">-->
<!--                        <img style="width: 400Px; height: calc(400px * (9 / 16));" :src="item.blog_poster"-->
<!--                             class="card-img">-->
<!--                        <div class="p-2">-->
<!--                            <h6 class="">{{item.blog_title}}</h6>-->
<!--                            <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </carousel>-->
<!--        <div v-if="!oracle.isMobile()" style="display: flex; flex-direction: row">-->
<!--            <div class="ml-auto"></div>-->
<!--            <span role="button" @click="$router.push('/blog')" class="font-weight-bold text-warning">-->
<!--                {{language.lang(`Read more articles`)}}-->
<!--            <i :class="[!isEN ? 'fa fa-chevron-left ml-1' : 'fa fa-chevron-right ml-1']"></i></span>-->
<!--            <div class="mr-auto"></div>-->
<!--        </div>-->
        <div :class="[!isEN ? 'style-rtl' :'', 'container']">
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div v-if="!oracle.isMobile()">
                    <div class="copyright" style="font-family: sans-serif !important;">
                        &copy; {{year}}
                        <span>Visternet Team</span>
                    </div>
                </div>
                <div class="text-lg-center btn-wrapper mr-auto ml-auto">
                    <a v-ripple v-for="(item, index) in socials" target="_blank" rel="noopener" :href="item.social_url"
                       class="social m-1" data-toggle="tooltip" :key="index">
                        <img class="center_cropped" :src="item.social_avatar">
                    </a>
                </div>
                <div v-if="!oracle.isMobile()">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <span role="button" @click="$router.push('/accounts/login')" class="nav-link">{{language.lang('Consultant dashboard')}}</span>
                        </li>
                        <li class="nav-item">
                            <span role="button" @click="$router.push('/contact')" class="nav-link">{{language.lang('Contact')}}</span>
                        </li>
                        <li class="nav-item">
                            <span role="button" @click="$router.push('/about')" class="nav-link">{{language.lang('About')}}</span>
                        </li>
                        <li class="nav-item">
                            <span role="button" @click="$router.push('/rules')" class="nav-link">{{language.lang('Terms of use')}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import language from "@/utils/language";
    import oracle from "@/utils/oracle";
    import carousel from 'vue-owl-carousel'

    export default {
        name: 'app-footer',
        components: {carousel},
        data() {
            return {
                blogs: [],
                socials: [],
                oracle: oracle,
                year: new Date().getFullYear(),
                language: language,
                isEN: oracle.isEN(),
            }
        }, mounted() {
            oracle.axios('social/getList', {order_by: 'priority'}, (response) => {
                this.socials = response.data
            })
            oracle.axios('blog/getList', {order_by: 'priority', limit_by: 7}, (response) => {
                this.blogs = response.data
            })
        }
    };
</script>
<style>
    .style-rtl {
        direction: rtl !important;
        text-align: right;
    }

    .social, .social img {
        width: 25px;
        height: 25px;
    }
</style>
